import ContractFee from './index';

export default {
    path: '/home/contractfee',
    component: ContractFee,
    children: []
}